const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

async function walletFetch(path, options = {}) {
  const token = localStorage.getItem('developmentexpress_token');
  if (!token) throw new Error('auth_required');
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export function fetchBankDetails() {
  return walletFetch('/api/wallet/bank-details');
}

export function createUpiQr(userId, amount) {
  return walletFetch('/api/wallet/create-upi-qr', {
    method: 'POST',
    body: JSON.stringify({ userId, amount }),
  });
}

export function fetchQrStatus(qrId) {
  return walletFetch(`/api/wallet/qr-status/${encodeURIComponent(qrId)}`);
}

export function submitBankTransferRequest({ userId, amount, method, utr }) {
  return walletFetch('/api/wallet/bank-transfer-request', {
    method: 'POST',
    body: JSON.stringify({ userId, amount, method, utr }),
  });
}

export function fetchBankTransferRequests(userId) {
  return walletFetch(`/api/wallet/bank-transfer-requests?userId=${encodeURIComponent(userId)}`);
}

export function fetchAdminBankTopups(status = 'pending') {
  return walletFetch(`/api/admin/bank-topups?status=${encodeURIComponent(status)}`);
}

export function approveBankTopup(id, note) {
  return walletFetch(`/api/admin/bank-topups/${id}/approve`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}

export function rejectBankTopup(id, note) {
  return walletFetch(`/api/admin/bank-topups/${id}/reject`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}

export function submitWithdrawRequest(body) {
  return walletFetch('/api/wallet/withdraw-request', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function fetchWithdrawRequests() {
  return walletFetch('/api/wallet/withdraw-requests');
}

export function fetchAdminWithdrawRequests(status = 'pending') {
  return walletFetch(`/api/admin/withdraw-requests?status=${encodeURIComponent(status)}`);
}

export async function approveWithdrawRequest(id, body) {
  const token = localStorage.getItem('developmentexpress_token');
  if (!token) throw new Error('auth_required');

  const payload = typeof body === 'string' ? { note: body } : (body || {});
  const hasFile = payload.proofFile instanceof File;

  let fetchOptions;
  if (hasFile) {
    const form = new FormData();
    form.append('utr', payload.utr || '');
    if (payload.note) form.append('note', payload.note);
    form.append('proof', payload.proofFile);
    fetchOptions = {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form,
    };
  } else {
    fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        utr: payload.utr,
        note: payload.note,
      }),
    };
  }

  const res = await fetch(`${API_BASE_URL}/api/admin/withdraw-requests/${id}/approve`, fetchOptions);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export function fetchDualApprovals(status = 'pending_second_approval') {
  return walletFetch(`/api/admin/dual-approvals?status=${encodeURIComponent(status)}`);
}

export function approveDualApproval(id, note) {
  return walletFetch(`/api/admin/dual-approvals/${id}/approve`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}

export function rejectDualApproval(id, note) {
  return walletFetch(`/api/admin/dual-approvals/${id}/reject`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}

export function runWalletReconciliation() {
  return walletFetch('/api/admin/wallet-reconciliation/run', { method: 'POST' });
}

export function rejectWithdrawRequest(id, note) {
  return walletFetch(`/api/admin/withdraw-requests/${id}/reject`, {
    method: 'POST',
    body: JSON.stringify({ note }),
  });
}

export function fetchAdminTreasury() {
  return walletFetch('/api/admin/treasury');
}

export function fetchPendingSettlements(status = 'pending_transfer') {
  return walletFetch(`/api/admin/pending-settlements?status=${encodeURIComponent(status)}`);
}

export function retryPendingSettlement(id) {
  return walletFetch(`/api/admin/pending-settlements/${id}/retry`, { method: 'POST' });
}

export function submitClientRefund({ bookingId, bookingRef, note }) {
  return walletFetch('/api/admin/client-refunds', {
    method: 'POST',
    body: JSON.stringify({ bookingId, bookingRef, note }),
  });
}

export function submitOwnerPayout({ ownerId, amount, reference, note }) {
  return walletFetch('/api/admin/owner-payouts', {
    method: 'POST',
    body: JSON.stringify({ ownerId, amount, reference, note }),
  });
}
